
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { bp: '-200', mve: 8815 },
  { bp: '-100', mve: 8533 },
  { bp: '0', mve: 8250 },
  { bp: '+100', mve: 7967 },
  { bp: '+200', mve: 7686 },
  { bp: '+300', mve: 7404 },
  { bp: '+400', mve: 7122 },
];

const MVESimChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="bp" label={{ value: 'Rate Change (bps)', position: 'insideBottom', offset: -5 }} />
        <YAxis domain={[7000, 9000]} label={{ value: 'MVE (₹ Cr)', angle: -90, position: 'insideLeft' }} />
        <Tooltip 
          formatter={(value) => [`₹${value} Cr`, 'Market Value of Equity']}
          labelFormatter={(label) => `Rate Change: ${label} bps`}
        />
        <Legend />
        <Line 
          type="monotone" 
          dataKey="mve" 
          name="Market Value of Equity" 
          stroke="#22c55e" 
          strokeWidth={2} 
          dot={{ r: 4 }} 
          activeDot={{ r: 6 }} 
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default MVESimChart;
